<form [formGroup]="form" (ngSubmit)="onSave()">

  <div class="p-fluid p-grid">
    <div class="p-col-12 p-md-6 p-field">
      <label for="pkg-name">Name <span class="req">*</span></label>
      <input
        id="pkg-name"
        type="text"
        pInputText
        formControlName="name"
        placeholder="e.g. Simple"
      />
      <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid" class="p-error">
        Name is required.
      </small>
    </div>

    <div class="p-col-12 p-md-6 p-field">
      <label for="pkg-slug">URL slug <span class="req">*</span></label>
      <input
        id="pkg-slug"
        type="text"
        pInputText
        formControlName="slug"
        placeholder="e.g. simple"
      />
      <small class="muted">Lowercase letters, numbers, and hyphens only.</small>
      <small *ngIf="form.get('slug')?.touched && form.get('slug')?.invalid" class="p-error">
        Slug must be lowercase letters, numbers, and hyphens.
      </small>
    </div>

    <div class="p-col-12 p-field">
      <label for="pkg-tagline">Tagline</label>
      <input
        id="pkg-tagline"
        type="text"
        pInputText
        formControlName="tagline"
        placeholder="e.g. Direct cremation, no service"
      />
    </div>

    <div class="p-col-12 p-field">
      <label for="pkg-description">Description</label>
      <textarea
        id="pkg-description"
        pInputTextarea
        formControlName="description"
        rows="3"
        placeholder="One paragraph for the brochure-site detail."
      ></textarea>
    </div>

    <div class="p-col-12 p-md-4 p-field">
      <label class="checkbox-label">
        <p-checkbox formControlName="isActive" [binary]="true"></p-checkbox>
        Active
      </label>
      <small class="muted">Inactive packages are hidden from the public site.</small>
    </div>

    <div class="p-col-12 p-md-4 p-field">
      <label class="checkbox-label">
        <p-checkbox formControlName="isFeatured" [binary]="true"></p-checkbox>
        Featured
      </label>
      <small class="muted">Featured packages get "Most popular" treatment on the homepage.</small>
    </div>

    <div class="p-col-12 p-md-4 p-field">
      <label for="pkg-price">Price (AUD)</label>
      <p-inputNumber
        inputId="pkg-price"
        formControlName="price"
        mode="currency"
        currency="AUD"
        locale="en-AU"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        placeholder="(POA — quote on enquiry)"
      ></p-inputNumber>
      <small class="muted">Leave empty for "Quoted on enquiry".</small>
    </div>
  </div>

  <hr />

  <h4 class="items-header">Items (inclusions)</h4>
  <p class="muted">
    Plain-text inclusion lines for the brochure-site card. The arranger
    writes whatever describes the inclusion — there's no catalogue link.
    Item prices are optional and display-only; they don't affect the
    package headline.
  </p>

  <table class="items-table">
    <thead>
      <tr>
        <th>Label</th>
        <th style="width: 6rem">Qty</th>
        <th style="width: 9rem">Price</th>
        <th>Note</th>
        <th style="width: 3rem"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of items" [class.is-deleted]="item._meta.deleted">
        <td>
          <input
            type="text"
            pInputText
            [(ngModel)]="item.label"
            [ngModelOptions]="{ standalone: true }"
            placeholder="e.g. Premium oak coffin"
          />
        </td>
        <td>
          <input
            type="number"
            pInputText
            min="1"
            [(ngModel)]="item.quantity"
            [ngModelOptions]="{ standalone: true }"
          />
        </td>
        <td>
          <p-inputNumber
            [(ngModel)]="item.price"
            [ngModelOptions]="{ standalone: true }"
            mode="currency"
            currency="AUD"
            locale="en-AU"
            [minFractionDigits]="0"
            [maxFractionDigits]="2"
            placeholder="(optional)"
          ></p-inputNumber>
        </td>
        <td>
          <input
            type="text"
            pInputText
            [(ngModel)]="item.note"
            [ngModelOptions]="{ standalone: true }"
            placeholder="(optional)"
          />
        </td>
        <td class="row-actions">
          <button
            *ngIf="!item._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="onRemoveItem(item)"
          ></button>
          <button
            *ngIf="item._meta.deleted"
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            class="p-button-rounded p-button-success p-button-text"
            (click)="onRestoreItem(item)"
          ></button>
        </td>
      </tr>
      <tr *ngIf="items.length === 0">
        <td colspan="5" class="empty-row">No items yet — add one to start building this package.</td>
      </tr>
    </tbody>
  </table>

  <div class="items-footer">
    <button
      pButton
      pRipple
      type="button"
      label="Add item"
      icon="pi pi-plus"
      class="p-button-text"
      (click)="onAddItem()"
    ></button>
  </div>

  <div class="footer-buttons">
    <button
      pButton
      pRipple
      type="button"
      label="Cancel"
      class="p-button-secondary"
      (click)="onCancel()"
    ></button>
    <button
      pButton
      pRipple
      type="submit"
      label="Save"
      [disabled]="form.invalid"
    ></button>
  </div>

</form>
